import { fg } from '@atlaskit/platform-feature-flags/fg';

// https://switcheroo.atlassian.com/ui/gates/rovo_fps_lead_user_as_title
export default {
	get(): boolean {
		return fg('rovo_fps_lead_user_as_title');
	},
};
